const TABBABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

/** jsdom has no layout, so without checkVisibility everything counts as rendered. */
const isRendered = (element: HTMLElement) =>
  typeof element.checkVisibility === 'function' ? element.checkVisibility() : true;

export const isTabbable = (element: HTMLElement) =>
  element.tabIndex >= 0 &&
  !element.matches(':disabled') &&
  !element.closest('[hidden], [aria-hidden="true"], [inert]') &&
  isRendered(element);

export const getTabbableElements = (scope: ParentNode) =>
  Array.from(scope.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR)).filter(isTabbable);

export const comesAfter = (reference: Node, candidate: Node) =>
  Boolean(reference.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING);

export const findNextTabbable = (
  tabbables: HTMLElement[],
  from: HTMLElement,
  backwards: boolean,
) => {
  if (!backwards) return tabbables.find((candidate) => comesAfter(from, candidate));
  const preceding = tabbables.filter((candidate) => comesAfter(candidate, from));
  return preceding[preceding.length - 1];
};

/** The first tabbable element after `reference` and outside it, skipping anything inside `skip`. */
export const findTabbableAfter = (
  reference: HTMLElement,
  scope: ParentNode = reference.ownerDocument.body,
  skip?: Node | null,
) =>
  getTabbableElements(scope).find(
    (candidate) =>
      !reference.contains(candidate) &&
      !skip?.contains(candidate) &&
      comesAfter(reference, candidate),
  );
